<template>
  <div class="page" id="page-insurance-detail">

    <div v-if="location.indexOf('prepared=false') != -1 ">
      <template>
       <div class="card-frame">
          <div class="noitems">
             <img :src="'../../static/info_gray.png'"/>
               상세내용 준비중입니다.<br>
               담당자에게 연락주시면 신속하게 확인해드리겠습니다.
             <button @click="prepare('16681100')">대표번호: 1668-1100</button>

           </div>
       </div>
      </template>
    </div>
    <div v-if="this.EstimateTF == false">
      <template>
       <div class="card-frame">
          <div class="noitems">
             <img :src="'../../static/info_gray.png'"/>
               보험료 산출 중에 있습니다. <br>
               신속한 보험료 산출을 원하시는 경우 상담예약 해주시기 바랍니다.
             <button @click="prepare('16681100')" style="padding-bottom:1rem;">대표번호: 1668-1100</button>
             <!-- <router-link tag="li" class="button schema" :to="{ name: 'EstimateConsultation' }" style="color: white;background-color: #0b2573;border-radius: 3px;padding: 1rem 0;">보험 가입신청</router-link> -->
             <!-- <router-link tag="li" class="button schema" v-if="data"
             :to="{ name: 'EstimateConsultation',
             query: { ectype: data[0].value[0].value + '보험', admin: data[4].value[0].adminid, customer: $store.state.customer.profile._id }
             }" >
               {{data[0].value[0].value}}보험 상담신청
               </router-link> -->

           </div>
       </div>
      </template>
    </div>
    <div class="header" v-if="location.indexOf('prepared=true') != -1 &&  this.EstimateTF == true">
    <div class="container">
      <div class="section-insure">
        <div class="banners">
          <div v-if="insureType === 'contract'" class="banner">가입보험</div>
          <div v-if="insureType === 'estimate'" class="banner schema2">비교견적</div>
          <div v-if="insureType === 'change'" class="banner">계약변경</div>
          <div v-if="insureType === 'accident'" class="banner">사고보상</div>


          <div v-if="(insureType === 'estimate' || insureType === 'contract') && data" class="banner schema">
            {{data[0].value[0].value}}보험
          </div>
          <div v-if="insureType === 'change' && changeContractDetail" class="banner schema">{{changeContractDetail.estimate_type}}보험</div>
          <div v-if="insureType === 'accident' && accidentDetail" class="banner schema">{{accidentDetail.estimate_type}}보험</div>
        </div>


        <template v-if="insureType === 'estimate'">
          <!-- <div class="title" v-if="data">{{data[0].value[0].value}}보험 견적서</div> -->
          <template v-if="!isMileage">
            <div class="title" v-if="data">{{data[0].value[0].value}}보험 견적서</div>
          </template>

          <template v-else>
            <div class="sub-title" v-if="data">{{ estimateList[indexTab][minimumIndex].title }} 선택시</div>
            <div class="title" v-if="data">
              <span style="color:#BF1F1F !important;">최대 {{ Number(estimateList[indexTab][maximumIndex].price - estimateList[indexTab][minimumIndex].price).toLocaleString() }}원</span>을<br>절약할 수 있습니다.
            </div>
          </template>
        </template>
        <template v-else>
          <div class="title" v-if="bodyInfo && bodyInfo.title">{{bodyInfo.title}}</div>
        </template>
        <div v-if="insureType === 'contract' || insureType === 'change' || insureType === 'accident'" class="img">
          <img v-if="bodyInfo && bodyInfo.title" :src="$store.state.allianceImgList.find(o=> bodyInfo.title.indexOf(o.name) >= 0).value" />
        </div>
        <!--
        <div class="subtitle">
          이태우님께서 2019년 04월 11일에 신청하신 자동차 보험의 현대해상 상세 견적서는 다음과 같습니다.
        </div>-->
      </div>

      <template v-if="insureType === 'contract'">
        <div class="section-information">
          <ul>
            <li>
              <p class="title">보험사</p>
              <p class="description">{{ bodyInfo.company }}</p>
            </li>

            <li>
              <p class="title">계약번호</p>
              <p class="description">{{ bodyInfo.contractNumber }}</p>
            </li>

            <li>
              <p class="title">가입기간</p>
              <p class="description">{{ bodyInfo.period_start }} ~ {{ bodyInfo.period_end }}</p>
            </li>

            <li>
              <p class="title">보험료</p>
              <p class="description">{{ bodyInfo.amount + "원" | number }}</p>
            </li>
          </ul>
        </div>

        <ul class="buttons">

          <router-link tag="li" class="button schema" v-if="data"
          :to="{ name: 'EstimateConsultation',
          query: { ectype: data[0].value[0].value + '보험', admin: data[4].value[0].adminid, customer: this.setContractCustomerId }
          }" >
            {{data[0].value[0].value}}보험 상담신청
            </router-link>
          <!--<router-link tag="li" class="button schema" v-if="data" :to="{ name: GetinsurancesName(data[0].value[0].value + '보험'), query: { step: true } }" >가입보험 가입신청</router-link>-->
          <li class="button" @click="openKakao(data[4].value[0].kakaotalk)" >담당사원 카카오톡</li>
        </ul>
      </template>

      <template v-if="insureType === 'estimate'">
        <div class="section-estimate-list">
          <div style="display:flex; justify-content: space-between;">
            <span class="section-label">보험료 비교표</span>
            <span class="section-label-img"
              @click.prevent="tooltipOn">
              <!-- @mouseout="tooltipOff" -->
              <svg width="16" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg" style="margin-right:2px;">
              <path d="M10.0833 13V11C10.0833 10.9028 10.0521 10.8229 9.98958 10.7604C9.92708 10.6979 9.84722 10.6667 9.75 10.6667H7.75C7.65278 10.6667 7.57292 10.6979 7.51042 10.7604C7.44792 10.8229 7.41667 10.9028 7.41667 11V13C7.41667 13.0972 7.44792 13.1771 7.51042 13.2396C7.57292 13.3021 7.65278 13.3333 7.75 13.3333H9.75C9.84722 13.3333 9.92708 13.3021 9.98958 13.2396C10.0521 13.1771 10.0833 13.0972 10.0833 13ZM12.75 6C12.75 5.38889 12.5573 4.82292 12.1719 4.30208C11.7865 3.78125 11.3056 3.37847 10.7292 3.09375C10.1528 2.80903 9.5625 2.66667 8.95833 2.66667C7.27083 2.66667 5.98264 3.40625 5.09375 4.88542C4.98958 5.05208 5.01736 5.19792 5.17708 5.32292L6.55208 6.36458C6.60069 6.40625 6.66667 6.42708 6.75 6.42708C6.86111 6.42708 6.94792 6.38542 7.01042 6.30208C7.37847 5.82986 7.67708 5.51042 7.90625 5.34375C8.14236 5.17708 8.44097 5.09375 8.80208 5.09375C9.13542 5.09375 9.43229 5.18403 9.69271 5.36458C9.95312 5.54514 10.0833 5.75 10.0833 5.97917C10.0833 6.24306 10.0139 6.45486 9.875 6.61458C9.73611 6.77431 9.5 6.93056 9.16667 7.08333C8.72917 7.27778 8.32812 7.57812 7.96354 7.98438C7.59896 8.39062 7.41667 8.82639 7.41667 9.29167V9.66667C7.41667 9.76389 7.44792 9.84375 7.51042 9.90625C7.57292 9.96875 7.65278 10 7.75 10H9.75C9.84722 10 9.92708 9.96875 9.98958 9.90625C10.0521 9.84375 10.0833 9.76389 10.0833 9.66667C10.0833 9.53472 10.158 9.36285 10.3073 9.15104C10.4566 8.93924 10.6458 8.76736 10.875 8.63542C11.0972 8.51042 11.2674 8.41146 11.3854 8.33854C11.5035 8.26562 11.6632 8.1441 11.8646 7.97396C12.066 7.80382 12.2205 7.63715 12.3281 7.47396C12.4358 7.31076 12.533 7.10069 12.6198 6.84375C12.7066 6.58681 12.75 6.30556 12.75 6ZM16.75 8C16.75 9.45139 16.3924 10.7899 15.6771 12.0156C14.9618 13.2413 13.9913 14.2118 12.7656 14.9271C11.5399 15.6424 10.2014 16 8.75 16C7.29861 16 5.96007 15.6424 4.73438 14.9271C3.50868 14.2118 2.53819 13.2413 1.82292 12.0156C1.10764 10.7899 0.75 9.45139 0.75 8C0.75 6.54861 1.10764 5.21007 1.82292 3.98438C2.53819 2.75868 3.50868 1.78819 4.73438 1.07292C5.96007 0.357639 7.29861 0 8.75 0C10.2014 0 11.5399 0.357639 12.7656 1.07292C13.9913 1.78819 14.9618 2.75868 15.6771 3.98438C16.3924 5.21007 16.75 6.54861 16.75 8Z" fill="#174BE6" fill-opacity="0.5"/>
              </svg>
              계약진행절차
            </span>
            <div id="tooltip"
              class="tooltip"
              style="display:none;">
              <div style="font-weight:700;">1. 견적</div>
              12개 보험사 중 가장 저렴한 견적을 찾아드립니다<br/>
              <div style="font-weight:700;">2. 심사</div>
              &lt;보험가입 가능여부 확인&gt;을 누르시면 선택한 보험사에 가입가능여부와 확정 보험료를 확인합니다<br/>
              <div style="font-weight:700;">3. 결제</div>
              가입승인된 보험상품에 결제정보를 등록하면 보험가입 절차가 진행됩니다.<br/>
              <div style="font-weight:700;">4. 서명</div>
              계약서에 서명하면 보험가입이 완료됩니다.<br/>
              <div style="font-weight:700;">5. 계약</div>
              계약이 완료된 상태입니다.<br/>
            </div>
          </div>

          <div id="tabs" class="container" style="padding:0px;">
            <div class="condition" >
              <a
                v-for="(items,index) in estimateList"
                :key="index"
                @click="() => { activetab = index; changeTab(index) }"
                v-bind:class="[ activetab === index ? 'active' : '' ]"
              >
                조건{{index+1}}
              </a>
            </div>

            <ul class="contents" >
              <li v-if="emailTF[indexTab] == false || estimateCompareSnArrTF[indexTab] == false" >
                <div>
                  <img src="/static/info_gray.png" style=" margin: 0 auto;width: 40px;" />
                  <span style="display: block;text-align: center; padding-top:10px;">보험료 산출 중에 있습니다. <br/>신속한 보험료 산출을 원하시는 경우 상담예약 해주시기 바랍니다.</span>
                </div>
              </li>

              <template v-for="(item, index) in estimateList[indexTab]">
                <li v-if="item.price > 0 && emailTF[indexTab] == true && item._sn == 1 && estimateCompareSnArrTF[indexTab] == true" :key="index">
                  <router-link  :to="{ name: 'InsuranceDetailPrice', query: { index: index, id: insureId, cdnId : indexTab , prepared : 'true', code: item.company_code, mile: isMileage } }">
                    <div class="img">
                      <img :src="$store.state.allianceImgList.find(o=> item.title.indexOf(o.name) >= 0).value" />
                    </div>

                    <template v-if="!isMileage">
                      <!-- <div class="title">
                        <p>{{ item.title }}</p>
                      </div> -->

                      <div :class="[ { price: true }, { min: !item.compare ? true: false }]">
                        <p style="color: #174be6">{{ item.price | number }}원</p>
                      </div>
                    </template>

                    <template v-else>
                      <div class="title multi-line">
                        <br>
                        <p v-if="isMileage">마일리지 할인</p>
                        <p v-if="isMileage">({{ mileObj[item.company_code].mileKm.toLocaleString() }}km)</p>
                      </div>

                      <div :class="[ { price: true }, { min: !item.compare ? true: false }]" class="multi-line">
                        <p style="color: #174be6">{{ item.price | number }}원</p>
                        <p v-if="isMileage" style="color: #000">{{ mileObj[item.company_code].mileage.toLocaleString() }}원</p>
                        <p v-if="isMileage" style="color: #bf1f1f; font-size: 12px">({{ (mileObj[item.company_code].price - mileObj[item.company_code].mileage).toLocaleString() }}원 후 할인)</p>
                      </div>
                    </template>

                    <div v-if="item.compare" :class="[ { compare: true }, { min: !item.compare ? true: false }]">
                      <i v-if="item.compare" class="fa fa-caret-up"></i>
                      {{ item.compare ? item.compare : '' | number }}원
                    </div>

                    <div class="function" ><i class="fa fa-angle-right"></i></div>
                  </router-link>
                </li>
              </template>
            </ul>
          </div>
        </div>
      </template>

      <template v-if="insureType === 'estimate'">
        <ul class="buttons">
          <router-link tag="li" class="button schema" v-if="data" :to="{ name: 'EstimateConsultation', query: { ectype: data[0].value[0].value + '보험', admin: 35, customer: this.setEstimateCustomerId, adminj : data[4].value[0].adminid, source : '홈피마이보험'} }" >{{data[0].value[0].value}}보험 가입상담</router-link>
          <li class="button" @click="openKakao(data[4].value[0].kakaotalk)" >담당사원 카카오톡</li>
        </ul>
      </template>

      <template v-if="insureType === 'change'">
        <div class="section-information">
          <ul>
            <li>
              <p class="title">보험사</p>
              <p class="description">{{ bodyInfo.company }}</p>
            </li>

            <li>
              <p class="title">계약번호</p>
              <p class="description">{{ bodyInfo.contractNumber }}</p>
            </li>

            <li>
              <p class="title">가입기간</p>
              <p class="description">{{ bodyInfo.period_start }} ~ {{ bodyInfo.period_end }}</p>
            </li>

            <li v-if="bodyInfo.autoNumber">
              <p class="title">차량번호</p>
              <p class="description">{{ bodyInfo.autoNumber }}5</p>
            </li>

            <li>
              <p v-if="bodyInfo.user" class="title">보험계약자</p>
              <p class="description">{{ bodyInfo.user }}</p>
            </li>
          </ul>
        </div>
        <ul class="buttons">
          <router-link tag="li" class="button schema"
          v-if="changeContractDetail && changeContractDetail.manager"
          :to="{ name: 'EstimateConsultation', query: { ectype: changeContractDetail.estimate_type + '보험', admin: changeContractDetail.manager.adminid, customer: $store.state.customer.profile._id } }" >{{changeContractDetail.estimate_type}}계약변경 신청하기</router-link>
          <li class="button" @click="openKakao(changeContractDetail.manager.kakaotalk)" >담당사원 카카오톡</li>
        </ul>
      </template>

      <template v-if="insureType === 'accident'">
        <div class="section-information">
          <ul>
            <li>
              <p class="title">보험사</p>
              <p class="description" v-if="bodyInfo && bodyInfo.title">{{ bodyInfo.title }}</p>
            </li>

            <li>
              <p class="title">계약번호</p>
              <p class="description">{{ bodyInfo.contractNumber }}</p>
            </li>

            <li>
              <p class="title">가입기간</p>
              <p class="description">{{ bodyInfo.period_start }} ~ {{ bodyInfo.period_end }}</p>
            </li>

            <li v-if="bodyInfo.autoNumber">
              <p class="title">차량번호</p>
              <p class="description">{{ bodyInfo.autoNumber }}</p>
            </li>

            <li>
              <p v-if="bodyInfo.user" class="title">보험계약자</p>
              <p class="description">{{ bodyInfo.user }}</p>
            </li>
          </ul>
        </div>
        <ul class="buttons">
          <router-link tag="li" class="button schema"
          v-if="accidentDetail && accidentDetail.manager"
          :to="{ name: 'EstimateConsultation', query: { ectype: accidentDetail.estimate_type + '보험', admin: accidentDetail.manager.adminid, customer: $store.state.customer.profile._id } }" >{{accidentDetail.estimate_type}}사고보상 신청하기</router-link>
          <li class="button" @click="openKakao(accidentDetail.manager.kakaotalk)" >담당사원 카카오톡</li>
        </ul>
      </template>
    </div>
    </div>


    <div v-if="insureType == 'estimate' || insureType == 'contract'" class="footer">
      <div class="container">
        <masonry :cols="{default: 2, 700: 1}" :gutter="30">
          <div class="section-information clear" v-if="data">
            <div class="title">
              {{ data[0].title }}
            </div>
            <ul>
              <template v-if="data[0].label != '구분'">
                <li v-for="(item, index) in data[0].value" :key="index">
                  <p class="label">{{ item.label }}</p>
                  <p class="value">{{ item.value }}</p>
                </li>
              </template>
            </ul>
          </div>

          <div class="section-information" v-if="data">
            <div class="title">
              {{ data[1].title }}
            </div>
            <ul>
              <li v-for="(item, index) in data[1].value" :key="index">
                <p class="label">{{ item.label }}</p>
                <p class="value">{{ item.value }}</p>
              </li>
            </ul>
          </div>

          <div class="section-information" v-if="data">
            <div class="title">
              {{ data[2].title }}
            </div>
            <ul>
              <li v-for="(item, index) in data[2].value" :key="index">
                <p class="label">{{ item.label }}</p>
                <p class="value">{{ item.value }}</p>
              </li>
            </ul>
          </div>

          <div v-if="clickInfo >= 0 && data[3].value[clickInfo].description" class="section-information">
            <div class="title">
              보험 용어 설명
            </div>
            <ul>
              <li>
                <p class="label" style="margin-right:10px;">{{ data[3].value[clickInfo].label }}</p>
                <p class="value">{{ data[3].value[clickInfo].description }}</p>
              </li>
            </ul>
          </div>

          <div class="section-information" v-if="data">
            <div class="title">
              {{ data[3].title }}
            </div>
            <ul>
              <li
                @click="clickInfo === index ? clickInfo = -1 : clickInfo = index"
                v-for="(item, index) in data[3].value"
                :key="index"
              >
                <p class="label" style="margin-right:10px;">{{ item.label }}</p>
                <p class="value">{{ item.value }}</p>
              </li>
            </ul>
          </div>

          <div class="section-information manager" v-if="data">
            <div class="title">
              {{ data[4].title }}
            </div>
            <div class="circle profile" :style="{'background-image': `url(${data[4].value[0].imgUrl})`}"
                style='background-repeat: no-repeat;background-position: center;background-size:cover;'>
            </div>
            <div class="item-frame">
              <div class="item">
                {{ data[4].value[0].name }}
              </div>
              <div class="item">
                {{ data[4].value[0].phone }}
              </div>
              <div class="item">
                {{ data[4].value[0].email }}
              </div>

            </div>
            <!--
            <div class="circle phone" @click="callPhone(data[4].value[0].phone.replace(/(-)/g,''))">
              <img :src="'/static/phone.png'" />
            </div>
            <div class="circle kakaotalk" @click="openKakao(data[4].value[0].kakaotalk)" >
              <img :src="'/static/kakao.png'" />
            </div>
            -->

            <!--<div class="img">
              <img :src="data[4].value[0].imgUrl" />
            </div>

            <div class="item">
              {{ data[4].value[0].name }}
            </div>

            <div class="item">
              {{ data[4].value[0].phone }}
            </div>

            <div class="item">
              {{ data[4].value[0].email }}
            </div>-->
          </div>
        </masonry>

      </div>
    </div>


    <div v-if="insureType == 'change'" class="footer">
      <div class="container">
        <masonry :cols="{default: 2, 700: 1}" :gutter="30">
          <div class="section-information clear" v-if="changeContractDetail.change">
            <div class="title" v-if="changeContractDetail.change.title">
              {{ changeContractDetail.change.title }}
            </div>
            <ul>
              <li >
                <p class="label">변경 요청일</p>
                <p class="value">{{ changeContractDetail.change.date_start }}</p>
              </li>
              <li >
                <p class="label">변경 유효일</p>
                <p class="value">{{ changeContractDetail.change.date_end }}</p>
              </li>
              <li >
                <p class="label">변경 내용</p>
                <p class="value">{{ changeContractDetail.change.contents }}</p>
              </li>
            </ul>
          </div>

          <div class="section-information manager">
            <div class="title" v-if="changeContractDetail.change && changeContractDetail.change.title">
              {{ changeContractDetail.manager.title }}
            </div>
            <div class="circle profile" v-if="changeContractDetail.manager"
                :style="{'background-image': `url(${changeContractDetail.manager.imgUrl})`}"
                style='background-repeat: no-repeat;background-position: center;background-size:cover;'>
            </div>

            <!--
            <div class="circle phone" v-if="changeContractDetail.manager && changeContractDetail.manager.phone" @click="callPhone(changeContractDetail.manager.phone.replace(/(-)/g,''))">
              <img :src="'/static/phone.png'" />
            </div>
            <div class="circle kakaotalk" v-if="changeContractDetail.manager && changeContractDetail.manager.kakaotalk" @click="openKakao(changeContractDetail.manager.kakaotalk)" >
              <img :src="'/static/kakao.png'" />
            </div>
            -->
            <div class="item-frame">
              <div class="item" v-if="changeContractDetail.manager">
                {{ changeContractDetail.manager.name }}
              </div>

              <div class="item" v-if="changeContractDetail.manager">
                {{ changeContractDetail.manager.phone }}
              </div>

              <div class="item" v-if="changeContractDetail.manager">
                {{ changeContractDetail.manager.email }}
              </div>
            </div>
          </div>
        </masonry>

      </div>
    </div>

    <div v-if="insureType == 'accident'" class="footer">
      <div class="container">
        <masonry :cols="{default: 2, 700: 1}" :gutter="30">
          <div class="section-information clear">
            <ul v-if="accidentDetail && accidentDetail.detail">
              <li >
                <p class="label">사고 접수번호</p>
                <p class="value">{{ accidentDetail.detail.accidentNumber }}</p>
              </li>
              <li >
                <p class="label">사고 접수 일시</p>
                <p class="value">{{ accidentDetail.detail.date_receipt }}</p>
              </li>
              <li >
                <p class="label">사고 일시</p>
                <p class="value">{{ accidentDetail.detail.date_accident }}</p>
              </li>
              <li v-if="accidentDetail.type === '자동차보험'">
                <p class="label">운전자명</p>
                <p class="value">{{ accidentDetail.detail.user }}</p>
              </li>
              <li v-if="accidentDetail.type !== '자동차보험'" >
                <p class="label">피보험자</p>
                <p class="value">{{ accidentDetail.detail.user }}</p>
              </li>
              <li v-if="accidentDetail.type === '자동차보험'" >
                <p class="label">피보험자 관계</p>
                <p class="value">{{ accidentDetail.detail.userRelation }}</p>
              </li>
              <li v-if="accidentDetail.type === '자동차보험'" >
                <p class="label">사고 장소</p>
                <p class="value">{{ accidentDetail.detail.location }}</p>
              </li>
              <!-- <li>
                <button @click="$refs.modalSendTextModal.show();">접수번호 문자 발송</button>
              </li> -->
            </ul>
          </div>

          <div class="section-information manager" v-if="accidentDetail.manager">
            <div class="title" v-if="accidentDetail.manager && accidentDetail.manager.title">
              {{ accidentDetail.manager.title }}
            </div>
            <div class="circle profile" v-if="accidentDetail.manager" :style="{'background-image': `url(${accidentDetail.manager.imgUrl})`}"
                style='background-repeat: no-repeat;background-position: center;background-size:cover;'>
            </div>
            <!--
            <div class="circle phone" v-if="accidentDetail.manager && accidentDetail.manager.phone" @click="callPhone(accidentDetail.manager.phone.replace(/(-)/g,''))">
              <img :src="'/static/phone.png'" />
            </div>
            <div class="circle kakaotalk" v-if="accidentDetail.manager && accidentDetail.manager.kakaotalk" @click="openKakao(accidentDetail.manager.kakaotalk)" >
              <img :src="'/static/kakao.png'" />
            </div>
            -->


            <div class="item-frame">
              <div class="item">
                {{ accidentDetail.manager.name }}
              </div>

              <div class="item">
                {{ accidentDetail.manager.phone }}
              </div>

              <div class="item">
                {{ accidentDetail.manager.email }}
              </div>
            </div>

          </div>
        </masonry>

      </div>
    </div>

    <div class="footer" style="background-color: #fff;">
      <div class="container">
        <p style="font-size: 11px;" >※ 이 견적서의 보험료는 보험가입일, 보험개발원 적용율, 보험사별 차량가액 및 인수 기준에 따라 변경될 수 있습니다.</p>
      </div>
    </div>

    <SendTextModal ref="modalSendTextModal">
      <div class="modal-page">
        <h2>문자 발송</h2>
        <div class="section">
          <div class="container">
            <label class="title">접수 번호 전달 내용</label>
            {{insureNumber}}
            <div class="contents" v-if="sendingMessage[insureNumber] && sendingMessage[insureNumber].msg">{{ sendingMessage[insureNumber].msg }}</div>
          </div>
          <div class="container list">
            <div class="left-side">
              <div v-for="(item, index) in sendingList" class="left-list" :key="index">
                {{ item.name }}
              </div>
              <label class="title">받는사람</label>
              <input v-model="sendingForm.name"/>
            </div>

            <div class="right-side">
              <div v-for="(item, index) in sendingList" class="right-list" :key="index">
                {{ item.phone }}
              </div>
              <label class="title">휴대폰번호</label>
              <input v-model="sendingForm.phone"/>
            </div>
            <button @click="addList">받는 사람 추가</button>
          </div>
          <div class="buttons">
            <button class="white" @click="$refs.modalSendTextModal.close();">취소</button>
            <button class="schema" @click="sendMessage">발송</button>
          </div>
        </div>
      </div>
    </SendTextModal>
  </div>
</template>

<script>

import moment from 'moment';
import SendTextModal from '@/components/Elements/SendTextModal.vue';

  export default {
    components: { SendTextModal },
    data() {
      return {
        setEstimateCustomerId : '',
        setContractCustomerId : '',
        emailTF : [],
        estimateCompareSnArrTF : [],
        activetab: 0 ,
        indexTab : 0,
        tagValue : '',
        tabArray : [],
        location : location.href,
        insureType: "",
        insureNumber: 0,
        insureId: 0,

        sendingForm: {
          name: '',
          phone: '',
        },

        bodyInfo: {
        },

        clickInfo: -1,

        sendingList: [],

        sendingMessage: [
          { msg: '[인슈넷FC] 서은영(57가1234) 현대해상 사고접수번호 1804-039465 알려드립니다.' },
          { msg: '[인슈넷FC] 손강/흥국/(무)프리미엄더긴상해보험/접수번호 1804-039465' },
          { msg: '[인슈넷FC] 서은영/흥국/(무)프리미엄더긴상해보험/접수번호 1804-039465' },
        ],

        condition: [],
        company: [
          { label: "hd", value: "현대해상" },
          { label: "ss", value: "삼성화재" },
          { label: "db", value: "DB손해보험" },
          { label: "lg", value: "KB손해보험" },
          { label: "ji", value: "MG손해보험" },
          { label: "sd", value: "한화손해보험" },
          { label: "sy", value: "흥국화재" },
          { label: "dh", value: "롯데손해보험" },
          { label: "dy", value: "메리츠화재" },
          { label: "hn", value: "하나손해보험" },
        ],
        estimateList: [
        ],
        EstimateTF: true,

        changeContractList: [
        ],

        accidentList: [
        ],

        changeContractDetail:
          {

          },

        accidentDetail:
          {

          },

        data: null,
        insurances: [
          { name: "자동차보험", src: "../static/home-insurance-1.png", component: "CarInsurance", value: "자동차보험", label: "자동차보험"},
          { name: "운전자보험", src: "../static/home-insurance-2.png", component: "DriverInsurance", value: "운전자보험", label: "운전자보험"},
          { name: "실손의료보험", src: "../static/home-insurance-3.png", component: "EstimateLosslessMedicalInsurance", value: "실손의료보험", label: "실손의료보험"},
          { name: "암/2대질병 보험", src: "../static/home-insurance-4.png", component: "CancerInsurance", value: "암/2대질병 보험", label: "암/2대질병 보험"},
          { name: "어린이보험", src: "../static/home-insurance-5.png", component: "ChildInsurance", value: "어린이보험", label: "어린이보험"},
          { name: "태아보험", src: "../static/home-insurance-6.png", component: "FetalInsurance", value: "태아보험", label: "태아보험"},
          { name: "정기보험", src: "../static/home-insurance-7.png", component: "TermInsurance", value: "정기보험", label: "정기보험"},
          { name: "종신보험", src: "../static/home-insurance-8.png", component: "WholeLifeInsurance", value: "종신보험", label: "종신보험"},
          { name: "화재보험", src: "../static/home-insurance-9.png", component: "FireInsurance", value: "화재보험", label: "화재보험"},
          { name: "연금보험", src: "../static/home-insurance-10.png", component: "PensionInsurance", value: "연금보험", label: "연금보험"},
          { name: "치아보험", src: "../static/home-insurance-11.png", component: "DentalInsurance", value: "치아보험", label: "치아보험"},
          { name: "치매보험", src: "../static/home-insurance-12.png", component: "DementiaInsurance", value: "치매보험", label: "치매보험"},
          { name: "펫보험", src: "../static/home-insurance-13.png", component: "PetInsurance", value: "펫보험", label: "펫보험" }
        ],
        tooltip: false,
        mileObj: {},
        minimumIndex: 0,
        maximumIndex:0,
        isMileage: false,
      }
    },
    created(){
      this.insureType = this.$route.query.type;
      this.insureNumber = this.$route.query.index;
      this.insureId = this.$route.query.id;
      this.isMileage = this.$route.query.mile || false;


      if(this.insureType === 'estimate'){
        this.setEstimateData();
      }
      else if(this.insureType === 'contract'){
        this.setContractData();
      }
      else if(this.insureType === 'change'){
        this.setChangeData();
      }
      else if(this.insureType === 'accident'){
        this.setAccidentData();
      }

      // if (!(location.href.indexOf('compare_id=') != -1 )) {
      //   location.href = location.href + '?compare_id=' + this.estimateData[0].estimate_condition_id;
      // }
      /*this.$store.dispatch( "customer/refresh", {} ).then(res => {
        this.token = localStorage.eleToken;
        let profile = this.$store.state.customer.profile;

        if(this.token && profile._id){

          let extra = profile ? JSON.parse(profile.customer_extra) : null;

          this.$store.dispatch( "estimate/getItems", { "_id": 340011 } ).then(res => {


          })

        }

      })
      */

      /*
      this.$store.dispatch( "estimate/get", { "id": this.$route.query.id } ).then(res => {

        this.condition = res.data.data.items[0];
        this.$store.dispatch( "estimate/getAutoItem", { "autocode": res.data.data.items[0].auto_code } ).then(res => {

          var auto = res.data.data;

          /*title: "차량정보",
          value: [
            { label: "차량번호", value: "16가6878" },
            { label: "차명", value: "기아, 올뉴 K7 3.3 GDI, 리미티드 플러스, 오토, 에어컨, P/S, ABS, AIR-D, IM" },
            { label: "등록연도", value: "2016. 09. 16" },
          ]
          this.data[1].value[0].value = this.condition.auto_number;
          this.data[1].value[1].value = `${auto.제조사},${auto.차명},${auto.세분}`;
          this.data[1].value[2].value = moment(this.condition.auto_registe_date).format('YYYY. MM. DD');
        })

        //this.$store.dispatch( "estimate/getAuditItem", { "id": res.data.data.items[0].})
        /*
        this.$store.dispatch( "estimate/getCompareList", { "estimate_condition_id": res.data.data.items[0]._id } ).then(res => {
          this.estimateList = res.data.data.items;

          this.estimateList.forEach( o => {
            o.company = this.company.find(c => c.label === o.estimate_condition_compare_company)
            o.compare = o.estimate_condition_compare_amount - this.estimateList[0].estimate_condition_compare_amount;
          });

        })
      })
      */
    },

    mounted(){
      // var name = "cid";
      // var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
      //     results = regex.exec(location.search);
      // results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
      //
      // this.loadTab(results[1])

    },
    methods: {
      setEstimateData(){


        var _this = this;
        this.$store.dispatch( "estimate/getItem", { "_id": _this.insureId } ).then(res => {

          var compareList = res.data.data.conditionCompares;
          var estimates = res.data.data.estiates;
          var estimate = res.data.data.estiate;

          this.setEstimateCustomerId = estimate.customer_id;


          // URL로 접근하였을 경우 상세정보 항목 업데이트

          var name = "cid";
          var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
              results = regex.exec(location.search);
          results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
          if (results){
            for (let i = 0; i < estimates.length; i++) {
              if (estimates[i].estimate_condition_id == results[1]) {
                this.$data.indexTab = i
                break;
              }
            }
          }




          // 견적서 데이터가 없으면
          if (estimates.length < 1) this.EstimateTF = false;
          var extra = JSON.parse(estimates[this.$data.indexTab].estimate_condition_extra).condition;
          var extra_price = JSON.parse(estimates[this.$data.indexTab].estimate_condition_extra).price;
          const condition_extra = JSON.parse(estimates[this.$data.indexTab].estimate_condition_extra);
          
          this.company.map(({ label }) => {
            const after_mileage = condition_extra.insuman[`aftmile_${label}`] * 1 || 0;
            const original_price = condition_extra.insuman[label] * 1;
            const mileKm = condition_extra.insuman.mileKm * 1;

            this.mileObj[label] = {
              price: original_price,
              mileage: after_mileage,
              mileKm
            }
          })

          var ageInfo = {};

          for( let [key, value] of Object.entries(extra)) {
            if(key === '한정/연령특약'){
              ageInfo = value;
            }
          }

          for (let i = 0; i < estimates.length; i++) {
            if (estimates[i].estimate_date_email == null || estimates[i].estimate_date_email == undefined) this.emailTF.push(false);
            else this.emailTF.push(true);
          }


          var dataList = [];
          for (let i = 0; i < compareList.length; i++) {

            var tmp = [];
            compareList[i].forEach(o=> {
              const compareExtra = JSON.parse(o.estimate_condition_compare_extra);
              var c = {};
              c.title = this.company.filter(cc => cc.label == o.estimate_condition_compare_company)[0].value;
              c.price = o.estimate_condition_compare_amount;
              c.compare_id = o._id;
              c.condition_id = o.estimate_condition_id;
              c.compare = o.estimate_condition_compare_amount - (compareList[0][0].estimate_condition_compare_amount || 0);
              c._sn = o._sn;
              c.company_code = o.estimate_condition_compare_company;

              this.mileObj[o.estimate_condition_compare_company] = {
                ...this.mileObj[o.estimate_condition_compare_company],
                price: o.estimate_condition_compare_amount,
                mileage: compareExtra.마일리지후할인 || 0
              }

              tmp.push(c);
            })
            dataList.push(tmp);
          }




          if (estimates[this.$data.indexTab].auto_number == null || estimates[this.$data.indexTab].auto_number ==undefined) estimates[this.$data.indexTab].auto_number = '번호없음'

          if (estimates[this.$data.indexTab].auto_registe_date == null || estimates[this.$data.indexTab].auto_registe_date == undefined) estimates[this.$data.indexTab].auto_registe_date =''
          else estimates[this.$data.indexTab].auto_registe_date = moment(estimates[this.$data.indexTab].auto_registe_date).format('YYYY.MM.DD')


          var tempData = [
            {
              title: "기본정보",
              value: [
                { label: "보험종목", value: estimates[this.$data.indexTab].estimate_type },
                { label: "보험계약자", value: estimates[this.$data.indexTab].customer_name },
                { label: "보험기간", value:  moment(estimates[this.$data.indexTab].estimate_date_start).format('YYYY.MM.DD') +' ~ '+ moment(estimates[this.$data.indexTab].estimate_date_end).format('YYYY.MM.DD')  },
              ]
            },
            {
              title: "차량정보",
              value: [
                { label: "차량번호", value: estimates[this.$data.indexTab].auto_number },
                { label: "차명", value: estimates[this.$data.indexTab].autoName + ' ' + estimates[this.$data.indexTab].autoNameDetail },
                { label: "등록연도", value: estimates[this.$data.indexTab].auto_registe_date },
              ]
            },
            {
              title: "운전자정보",
              value: [
                { label: "운전자 범위", value: ageInfo.운전범위 },
                { label: "운전자 연령", value: ageInfo.운전연령 },
              ]
            },
            {
              title: "보장항목",
              value: [
                  { label: "대인배상 I", value: extra.담보사항.대인배상 ? '가입' : extra.담보사항.대인배상, description: "타인 사망 시 최고 1억5천만원, 타인 상해 시 최고 3천만원 한도에서 보상합니다. 법에 따른 의무보험으로 속칭 '책임보험'이라고 하며 미가입시 최고 90만원의 과태료, 1년 이하의 징역 또는 500만원 이하의 벌금형을 부과받습니다." },
                  { label: "대인배상 II", value: extra.담보사항.대인배상, description: "타인을 죽게 하거나 다치게 할 경우 대인배상I에서 보상하는 금액을 초과하는 손해를 보상합니다. 무한보상으로 가입하면 교통사고처리특례법에 따라 운전자가 형사처벌 면제 특례를 받으므로, 미가입 외에는 모두 '무한보상'을 선택합니다." },
                  { label: "대물배상", value: extra.담보사항.대물배상, description: "타인의 재물이나 차량에 손실을 입힐 경우 가입금액 한도 내에서 보상합니다. 의무보험으로 운전자가 형사처벌 면제 특례를 받으려면 2천만원 이상 가입해야 합니다." },
                  { label: "자기신체사고", value: extra.담보사항.자기신체사고, description: "차주 및 운전자, 그들의 가족이 교통 상해를 입을 경우 가입금액 한도 내에서 보상받습니다. 차주 및 운전자 가족 모두를 위한 교통상해보험에 가입하는 것이라고 볼 수 있습니다." },
                  { label: "무보험차상해", value: extra.담보사항.무보험차상해, description: "차주 및 운전자, 그들의 가족이 무보험차 또는 뺑소니차에게 상해를 입을 경우 가입금액 한도 내에서 보상 받습니다. 이 담보에 가입하면 '다른자동차운전담보특약'에 무료 가입되므로 다른 사람 차를 일시 운전하다 사고 발생 시 보상받을 수 있습니다." },
                  { label: "자기차량손해", value: extra.담보사항.자기차량손해, description: "자동차보험 가입 차량에 도난, 파손, 화재 등 발생 시 원상복구 금액을 가입금액 한도 내에서 보상합니다. 가입금액은 보험개발원에서 분기별로 발표하는 차량가액의 60%~100% 이내에서 결정할 수 있습니다." },
                  { label: "", value: `(${extra_price.total}만원 중 ${extra_price.apply}만원, ${extra_price.apply_percent}%)`, description: "" },
                  { label: "물적사고할증", value: extra.담보사항.물적할증기준, description: "" },
              ]
            },
            {
              title: "담당사원 정보",
              value: [
                {
                  adminid: estimates[this.$data.indexTab].admin_id,
                  imgUrl: estimates[this.$data.indexTab].adminProfileUrl,
                  name: estimates[this.$data.indexTab].admin_name,
                  phone: estimates[this.$data.indexTab].admin_contact_phone,
                  email: estimates[this.$data.indexTab].admin_email,
                  kakaotalk: estimates[this.$data.indexTab].adminKakaoLink,
                }
              ]
            }
          ]

          // push
          this.data = tempData;
          this.estimateList = dataList;
          this.minimumIndex = this.estimateList[this.indexTab].findIndex(e => e.price > 0 && e._sn === 1);
          this.maximumIndex = this.estimateList[this.indexTab].findLastIndex(e => e.price > 0 && e._sn === 1);


// sn 값이 모두 null 이 아니면 출력하며 아니면 출력 하지 않도록 함
          for (let j = 0; j < this.estimateList.length; j++) {
            for (let i = 0; i < this.estimateList[j].length; i++) {
              if (this.estimateList[j][i]._sn == 1) {
                this.estimateCompareSnArrTF[j] = true;
                break;
              }else{
                this.estimateCompareSnArrTF[j] = false;
              }
            }
          }


          this.loadTab()
          this.sendHangOutMsg(estimates[this.$data.indexTab].admin_email
          , estimates[this.$data.indexTab].auto_number
          , estimates[this.$data.indexTab].customer_name + "/" + _this.insureId + "/" + estimate.customer_id);

        })
      },
      changeTab(index){
        this.$data.indexTab = index;
        this.setEstimateData();

      },
      loadTab(){

        var name = "cid";
        var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
            results = regex.exec(location.search);
        results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
        if (results){
          var index = results[1];

          for (let i = 0; i < this.estimateList.length; i++) {
            if (this.estimateList[i][0].condition_id ==  index){

                this.$data.activetab = i;
                this.$data.indexTab = i;
                return i;
            }
          }
        }
      },
      setContractData(){

        var _this = this;
        this.$store.dispatch( "contract/getItem", { "_id": _this.insureId } ).then(res => {

          // if (res.data.data.estimaㄴte == undefined) {
          //   alert('문제가 발생했습니다.');
          //   history.back();
          // }


          var contract = res.data.data.contract;
          this.setContractCustomerId = contract.customer_id
          var estimate = res.data.data.estimate;
          var company = this.company;

          var extra = JSON.parse(estimate.estimate_condition_extra);
          var condition = JSON.parse(contract.contract_extra).condition.담보사항;
          //var total = JSON.parse(contract.contract_extra).condition_compare_extra.총금액;

          var total = JSON.parse(contract.contract_extra).condition_compare.estimate_condition_compare_amount;

          var ageInfo = {};

          for( let [key, value] of Object.entries(extra.condition)) {
            if(key === '한정/연령특약'){
              ageInfo = value;
            }
          }

          var bodyInfo = {
            title: company.filter(o => o.label == contract.contract_company)[0].value,
            company: company.filter(o => o.label == contract.contract_company)[0].value,
            contractNumber: contract.contract_number,
            period_start: moment(contract.contract_date_start).format('YYYY.MM.DD'),
            period_end: moment(contract.contract_date_end).format('YYYY.MM.DD'),
            amount: total,
          }


          var tempData = [
            {
              title: "기본정보",
              value: [
                { label: "보험종목", value: estimate.estimate_type },
                { label: "보험계약자", value: contract.contract_customer_name },
                { label: "피보험자", value: estimate.customer_name },
              ]
            },
            {
              title: "차량정보",
              value: [
                { label: "차량번호", value: estimate.auto_number },
                { label: "차명", value: estimate.autoName + ' ' + estimate.autoNameDetail },
                { label: "등록연도", value: moment(estimate.auto_registe_date).format('YYYY.MM.DD') },
              ]
            },
            {
              title: "운전자정보",
              value: [
                { label: "운전자 범위", value: ageInfo.운전범위 },
                { label: "운전자 연령", value: ageInfo.운전연령 },
              ]
            },
            {
              title: "보장항목",
              value: [
                  { label: "대인배상 I", value: condition.대인배상 ? '가입': condition.대인배상, description: "타인 사망 시 최고 1억5천만원, 타인 상해 시 최고 3천만원 한도에서 보상합니다. 법에 따른 의무보험으로 속칭 '책임보험'이라고 하며 미가입시 최고 90만원의 과태료, 1년 이하의 징역 또는 500만원 이하의 벌금형을 부과받습니다." },
                  { label: "대인배상 II", value: condition.대인배상, description: "타인을 죽게 하거나 다치게 할 경우 대인배상I에서 보상하는 금액을 초과하는 손해를 보상합니다. 무한보상으로 가입하면 교통사고처리특례법에 따라 운전자가 형사처벌 면제 특례를 받으므로, 미가입 외에는 모두 '무한보상'을 선택합니다." },
                  { label: "대물배상", value: condition.대물배상, description: "타인의 재물이나 차량에 손실을 입힐 경우 가입금액 한도 내에서 보상합니다. 의무보험으로 운전자가 형사처벌 면제 특례를 받으려면 2천만원 이상 가입해야 합니다." },
                  { label: "자기신체사고", value: condition.자기신체사고, description: "차주 및 운전자, 그들의 가족이 교통 상해를 입을 경우 가입금액 한도 내에서 보상받습니다. 차주 및 운전자 가족 모두를 위한 교통상해보험에 가입하는 것이라고 볼 수 있습니다." },
                  { label: "무보험차상해", value: condition.무보험차상해, description: "차주 및 운전자, 그들의 가족이 무보험차 또는 뺑소니차에게 상해를 입을 경우 가입금액 한도 내에서 보상 받습니다. 이 담보에 가입하면 '다른자동차운전담보특약'에 무료 가입되므로 다른 사람 차를 일시 운전하다 사고 발생 시 보상받을 수 있습니다." },
                  { label: "자기차량손해", value: condition.자기차량손해, description: "자동차보험 가입 차량에 도난, 파손, 화재 등 발생 시 원상복구 금액을 가입금액 한도 내에서 보상합니다. 가입금액은 보험개발원에서 분기별로 발표하는 차량가액의 60%~100% 이내에서 결정할 수 있습니다." },
                  { label: "", value: `(${extra.price.total}만원 중 ${extra.price.apply}만원, ${extra.price.apply_percent}%)`, description: "" },
                  { label: "물적사고할증", value: condition.물적할증기준, description: "" },
              ]
            },
            {
              title: "담당사원 정보",
              value: [
                {
                  adminid: estimate.admin_id,
                  imgUrl: estimate.adminProfileUrl,
                  name: estimate.admin_name,
                  phone: estimate.admin_contact_phone,
                  email: estimate.admin_email,
                  kakaotalk: estimate.adminKakaoLink,
                }
              ]
            }
          ]

          this.data = tempData;
          this.bodyInfo = bodyInfo;
        });
      },

      setChangeData(){
        var _this = this;
        this.$store.dispatch( "contract/getAuditItem", { "_id": _this.insureId } ).then(res => {

          var audit = res.data.data.audit;
          var audits = res.data.data.audits;


          if (location.search.indexOf('auid') != -1) {
            var name = "auid";
            var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
                results = regex.exec(location.search);
            results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
            for (let i = 0; i < audits.length; i++) {
              if (audits[i]._id == results[1]) {
                audit = audits[i];
                break;
              }
            }
          }



          var company = this.company;

          var bodyInfo = {
            title: company.filter(o => o.label == audit.contract_company)[0].value,
            company: company.filter(o => o.label == audit.contract_company)[0].value,
            contractNumber: audit.contract_number,
            period_start: moment(audit.contract_date_start).format('YYYY.MM.DD'),
            period_end: moment(audit.contract_date_end).format('YYYY.MM.DD'),
            autoNumber: audit.auto_number
          }

          var changeContractDetail = {
              estimate_type: audit.contract_type,
              change: {
                title: "변경내용",
                date_start: moment(audit.contract_endorsement_date_request).format('YYYY.MM.DD'),
                date_end: moment(audit.contract_endorsement_date_result).format('YYYY.MM.DD'),
                contents: audit.contract_endorsement_detail
              },
              manager: {
                title: "담당사원 정보",
                adminid: audit.admin_id,
                imgUrl: audit.adminProfileUrl,
                name: audit.admin_name,
                phone: audit.admin_contact_phone,
                email: audit.admin_email,
                kakaotalk: audit.adminKakaoLink,
              }
            }

            this.changeContractDetail = changeContractDetail;
            this.bodyInfo = bodyInfo;
        })
      },

      setAccidentData(){
        var _this = this;
        this.$store.dispatch( "contract/getAccidentItem", { "_id": _this.insureId } ).then(res => {
          var accident = res.data.data[0];

          var company = this.company;

          var bodyInfo = {
            title: company.filter(o => o.label == accident.contract_company)[0].value,
            contractNumber: accident.contract_number,
            period_start: moment(accident.contract_date_start).format('YYYY.MM.DD'),
            period_end: moment(accident.contract_date_end).format('YYYY.MM.DD'),
            autoNumber: accident.auto_number,
            user: '',
          };

          var accidentContractDetail = {
            estimate_type: accident.estimate_type,
            detail: {
              accidentNumber: accident.contract_accident_insurance_number,
              date_receipt: moment(accident.contract_accident_date_insurance).format('YYYY.MM.DD'),
              date_accident: moment(accident.contract_accident_date_insurance_notify).format('YYYY.MM.DD'),
              user: accident.contract_accident_driver_name,
              userRelation: accident.contract_accident_driver_relation,
              location: accident.contract_accident_place,
              charge: 'TODO',
            },
            manager: {
              title: "담당사원 정보",
              adminid: accident.admin_id,
              imgUrl: accident.adminProfileUrl,
              name: accident.admin_name,
              phone: accident.admin_contact_phone,
              email: accident.admin_email,
              kakaotalk: accident.adminKakaoLink,
            }
          }


          this.accidentDetail = accidentContractDetail;
          this.bodyInfo = bodyInfo;
        })
      },

      addList() {
        this.sendingList.push({ name: this.sendingForm.name, phone: this.sendingForm.phone });

        this.sendingForm.name = '';
        this.sendingForm.phone = '';
      },
      sendHangOutMsg(receiver, carNum, mg){
      
      var contents;
      contents = `[홈페이지 견적서 방문] ${carNum} 차량 ${mg.split('/')[0]} 고객님께서 홈페이지 보험료 비교표를 확인 중입니다./` 
      + mg.split('/')[1] + "/" + mg.split('/')[2];
      
      
      this.$store.dispatch( "etc/sendHangout", {
          "rp": receiver, // 상담원
          "mg" : contents // 내용
        } ).then( res => {});
    },

      sendMessage() {
        this.sendingList.forEach(o => {
          this.$store.dispatch( "etc/sendMessage", { data: o.phone, msg: this.sendingMessage[this.insureNumber].msg } ).then( res => {

            this.$refs.modalSendTextModal.close();
          });
        })
      },
      openKakao(link){
        window.open(link);
      },
      callPhone(link){
        window.open("tel:" + link);
      },
      GetinsurancesName (type) {
        var tmp = this.insurances.find(o =>{
          return o.name.indexOf(type) >= 0
        })
        if(tmp) return tmp.component;
        return ''
      },
      // 계약진행절차 tooltip
      tooltipOn() {
        const tooltip = document.getElementById('tooltip');
        if (!this.tooltip) {
          tooltip.style.display = 'block';
          this.tooltip = true;
          return;
        }
        tooltip.style.display = 'none';
        this.tooltip = false;
      },
    }
  }
</script>

<style lang="scss">
#page-insurance-detail .card-frame{overflow: auto;display: block;}
#page-insurance-detail .noitems {color: #787878;text-align: center;background-color: white;padding: 2rem;}
#page-insurance-detail .noitems img {width: 3rem;height: 3rem;margin: 1rem auto;}
#page-insurance-detail .noitems button{color: white;background-color: #174be6;border-radius: 4px;height: 50px;line-height: 50px;margin-top: 2rem;margin-bottom: 3rem;}



#tabs .container {
    max-width: 620px;
    min-width: 420px;
    margin: 40px auto;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 0.9em;
    color: #888;
}


/* #tabs .condition {
    overflow: hidden;
  margin-left: 20px;
    margin-bottom: -2px;
} */

#tabs  ul {
    list-style-type: none;
    margin-top: -10px;
    width: 100%;
    display: inline-block;
}
#tabs .condition {
    display: inline-block;
    width: 100%;
}


#tabs .condition a{
    float: left;
    cursor: pointer;
    padding: 12px 24px;
    transition: background-color 0.2s;
    border: 1px solid #ccc;
    border-right: none;
    background-color: white;
    border-radius: 10px 10px 0 0;
    font-weight: bold;
}
#tabs .condition a:last-child {
    border-right: 1px solid #ccc;
    border-bottom: 1px solid #fff;
}

#tabs .condition a:hover {
    background-color: #174be6;
    color: #fff;
}

#tabs .condition a.active {
    background-color: #fff;
    color: #174be6;
    border-bottom: 1px solid #fff;
    cursor: default;
}

#tabs .tabcontent {
    padding: 30px;
    border: 1px solid #ccc;
    border-radius: 10px;
  box-shadow: 3px 3px 6px #e1e1e1
}


.tooltip {
  position: absolute;
  @media (min-width: 320px) and (max-width: 359px) {
    margin-left: -160px;
    z-index: 300;
  }
  @media (min-width: 360px) and (max-width: 480px) {
    margin-left: -120px;
  }
  @media (min-width: 550px) and (max-width: 700px) {
    margin-left: 100px;
  }
  @media (min-width: 701px) {
    left: 300px;
  }
  margin-top: 70px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 12px 0px 0px 10px;
  color: #666568;

  background: #F3F6FF;
  width:300px;
  height:365px;
  position: absolute;
  top: -20px;
  left: 150px;
  z-index:1;

  font-family: NanumSquareOTF;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: -0.30000001192092896px;
  text-align: left;
}

.multi-line {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  line-height: unset !important;
}
</style>
